"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTextEllipsisClass = void 0;

var addTextEllipsisClass = function addTextEllipsisClass(labelElement) {
  if (labelElement) {
    var offsetWidth = labelElement.offsetWidth,
        scrollWidth = labelElement.scrollWidth;
    var isTextEllipsis = offsetWidth || scrollWidth ? offsetWidth < scrollWidth : false;

    if (isTextEllipsis) {
      labelElement.classList.add('control-label-ellipsis');
    }
  }
};

exports.addTextEllipsisClass = addTextEllipsisClass;